import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConfirmdialogComponent } from './confirmdialog.component';
import { ConfirmRoutingModule } from './confirm-routing.module';

import { CatalogueModule } from './../../component/catalogue/catalogue.module';
import { DemoModule } from './../../component/demo/demo.module';
import { CodeModule } from './../../component/code/code.module';

import {ConfirmDialogModule} from "../../component/ing/confirmdialog/confirmdialog";
import {GrowlModule} from "../../component/ing/growl/growl";
import {TableModule} from "../../component/ing/table/table";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ConfirmRoutingModule,
    CatalogueModule,
    DemoModule,
    CodeModule,
    ConfirmDialogModule,
    TableModule,
    GrowlModule
  ],
  declarations: [ConfirmdialogComponent]
})
export class ConfirmdialogDemoModule { }



// WEBPACK FOOTER //
// ./src/app/view/confirmdialog/confirmdialogDemo.module.ts